'use client';

import * as styles from '../styles.css';

import Select from '@blueshift-ui/inputs/dist/components/select';
import ContinueButton from '@nrdy-marketing-engine/cart/src/components/shared/continue-button';
import AccountFormValues from '@nrdy-marketing-engine/forms/@types/account-form-values';
import LearnerPanel from '@nrdy-marketing-engine/forms/@types/learner-panel';
import ControlledTextField from '@nrdy-marketing-engine/inputs/src/controlled-text-field';
import {
  firstNameRules,
  gradeRules,
  lastNameRules,
} from '@nrdy-marketing-engine/inputs/src/input-validation-rules';
import { GRADE_OPTIONS } from '@nrdy-marketing-engine/learner-forms/src/grades';
import { ChangeEvent } from 'react';
import { Controller } from 'react-hook-form';
import { logFieldChange } from '../../tracking-utils/freemium-forms-loggers';

export function CreateLearnerPanel({
  control,
  formState,
  loading,
  onSubmit,
}: LearnerPanel<AccountFormValues>) {
  const formInputsAreValid = !formState.isValid;
  const continueButtonProps = onSubmit ? { onClick: onSubmit } : { type: 'submit' as 'submit' };

  return (
    <>
      <div>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>Create a learner profile</h1>
          <p>Add additional learners to your account</p>
        </div>
        <div className={styles.inputWrapper}>
          <ControlledTextField
            className={styles.bottomSysSpace4}
            clearable
            control={control}
            controllerProps={{ rules: firstNameRules }}
            defaultValue={formState.defaultValues.first_name}
            error={Boolean(formState.errors.first_name?.message)}
            fullWidth
            helperText={formState.errors.first_name?.message}
            label="First name"
            name="first_name"
            onBlur={logFieldChange}
            placeholder="First name"
          />
        </div>
        <div className={styles.inputWrapper}>
          <ControlledTextField
            className={styles.bottomSysSpace4}
            clearable
            control={control}
            controllerProps={{ rules: lastNameRules }}
            defaultValue={formState.defaultValues.last_name}
            error={Boolean(formState.errors.last_name?.message)}
            fullWidth
            helperText={formState.errors.last_name?.message}
            label="Last name"
            name="last_name"
            onBlur={logFieldChange}
            placeholder="Last name"
          />
        </div>
        <div className={styles.inputWrapper}>
          <Controller
            control={control}
            defaultValue={''}
            name="grade_list_id"
            render={({ field: { ref: _omit, ...field } }) => (
              <Select
                className={styles.bottomSysSpace5}
                error={Boolean(formState.errors.grade_list_id?.message)}
                helperText={formState.errors.grade_list_id?.message}
                label={'Grade'}
                options={GRADE_OPTIONS}
                {...field}
                onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                  logFieldChange({
                    target: {
                      name: 'grade_list_id',
                      value: String(GRADE_OPTIONS[Number(e.target.value) - 1].label),
                    },
                  });
                  field.onChange(e);
                }}
              />
            )}
            rules={gradeRules}
          />
        </div>
      </div>
      <div className={styles.bottomTextAndLink}>
        <ContinueButton
          color="secondary"
          disabled={formInputsAreValid}
          loading={loading}
          onMouseUp={logFieldChange}
          {...continueButtonProps}
        >
          Save profile
        </ContinueButton>
      </div>
    </>
  );
}

export default CreateLearnerPanel;
